export const AboutData = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Zanim zaczniemy...',
    headline: 'Kilka słów o mnie',
    buttonLabel: 'Pakiety Treningowe',
    buttonRedirectId: 'training-plans',
    imgStart: false,
    img: require('../../images/image1.jpg'),
    alt: 'Michał Wojcieszak',
    dark: true,
    primary: true,
    darkText: false
};


export const ContactData = {
    id: 'contact',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Gotowy(a) na metamorfozę?',
    headline: 'Tu mnie znajdziesz',
    imgStart: false,
    img: require('../../images/RioTopGym.PNG'),
    img2: require('../../images/HolmesPlaceOVO.PNG'),
    alt: 'RioTop Gym Tarasy Grabiszynskie',
    alt2: 'Holmes Place OVO',
    dark: true,
    primary: true,
    darkText: false
};